import { Seo } from '../components/Seo';
import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import './Home.css';

const slides = [
  {
    image: '/img/slides/5.jpg',
    title: 'Curated Data Sets and Services',
    text: 'Unique data sets available for niche industries, and automation services for your own dataset.',
    cta: 'Explore Now',
    link: '/services'
  },
  {
    image: '/img/slides/6.jpg',
    title: 'Advanced Data Science',
    text: 'AI and Data Intelligence services using trusted, reliable technology',
    cta: 'Read more',
    link: '/services'
  },
  {
    image: '/img/slides/3.jpg',
    title: 'AI Process Automations',
    text: 'Our no-hype approach to selective human-in-the-loop process automation',
    cta: 'Learn More',
    link: '/services'
  },
  {
    image: '/img/slides/4.jpg',
    title: 'AI Incubator',
    text: 'A list of exciting projects looking for teams and investment',
    cta: 'Read more',
    link: '/incubator'
  }
];

const Home = () => {

  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((curr) => (curr + 1) % slides.length);
  }, []);

  const prev = () => setCurrent((curr) => (curr - 1 + slides.length) % slides.length);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <>


      <Seo
        title="Schwabe Enterprises - AI Development, Engineering, Consulting, Advanced Data Science, Tech Incubator"
        description="Schwabe Enterprises is a leading provider of AI development, engineering, consulting, advanced data science, and tech incubator services."
        type="webapp"
      />

      <Header selectedNavitem="home" />


      <div className="d-flex align-items-center justify-content-center min-vh-100 bg-light p-0 p-md-4">
        <div className="card shadow border-0 overflow-hidden card-container bg-white">
          {/* Image */}
          <div className="slide-image-container">
            <img
              src={slides[current].image}
              alt={slides[current].title}
              className="slide-image"
            />
          </div>

          {/* Content */}
          <div className="card-body text-center p-5">
            <h2 className="display-6 fw-bold text-dark mb-3">
              {slides[current].title}
            </h2>
            <p className="text-secondary mb-4 fs-5">
              {slides[current].text}
            </p>
            <Link to={slides[current].link} className="btn btn-primary px-4 py-2 my-2 fw-semibold">
              {slides[current].cta}
            </Link>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prev}
            className="nav-btn nav-left rounded-circle bg-white shadow position-absolute text-dark"
            aria-label="Previous slide"
          >
            <ChevronLeft size={24} />
          </button>
          <button
            onClick={next}
            className="nav-btn nav-right rounded-circle bg-white shadow position-absolute text-dark"
            aria-label="Next slide"
          >
            <ChevronRight size={24} />
          </button>

          {/* Dots Indicator */}
          <div className="dots-container">
            {slides.map((_, idx) => (
              <button
                key={idx}
                onClick={() => setCurrent(idx)}
                className={`dot ${idx === current ? 'active' : ''}`}
                aria-label={`Go to slide ${idx + 1}`}
              />
            ))}
          </div>
        </div>
      </div>

      <Footer />

    </>
  )
};

export default Home;